import {useNavigate, useParams} from "react-router";
import type {GroupRepo, ItemVariantId} from "../../models/GroupRepo";
import {Box, Col} from "../../ui/Box";
import Button from "../../ui/Button";
import Icon from "../../ui/Icon";
import RefineItem from "./RefineItem";

const EditItem = ({groupRepo}: {groupRepo: GroupRepo}) => {
  const params = useParams<{variantId: string}>();
  const navigate = useNavigate();
  const onClose = () => navigate("..");

  return (
    <Col sp="12" height="_addItemDrawerHeight">
      <Box absolute right="0" top="0" pt="4" pr="4">
        <Button onClick={onClose} variant="tertiary">
          <Icon name="close" />
        </Button>
      </Box>
      <RefineItem id={params.variantId as ItemVariantId} onClose={onClose} groupRepo={groupRepo} />
    </Col>
  );
};

export default EditItem;
